var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mt-4" }, [
    _c("div", { staticClass: "col-md-6 border-right mb-3" }, [
      _c("h5", [_vm._v("Roles Disponibles")]),
      _c(
        "div",
        { staticClass: "d-flex align-items-center justify-content-end" },
        [
          _c("b-form-input", {
            staticClass: "d-inline-block mr-1",
            attrs: { placeholder: "Filtrar...", "data-cy": "filter-role" },
            model: {
              value: _vm.searchInVacantRoles,
              callback: function($$v) {
                _vm.searchInVacantRoles = $$v
              },
              expression: "searchInVacantRoles"
            }
          })
        ],
        1
      )
    ]),
    _vm._m(0),
    _c(
      "div",
      { staticClass: "col-md-6 border-right" },
      [
        _c(
          "vs-list",
          { staticClass: "box-users" },
          [
            _vm._l(_vm.filteredAvailableRoles, function(role) {
              return _c(
                "div",
                { key: role.rolId, attrs: { "data-cy": "assigned-roles" } },
                [
                  role.asignado === "no"
                    ? _c(
                        "vs-list-item",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: role.descripcion,
                              expression: "role.descripcion"
                            }
                          ],
                          attrs: { title: role.nombre }
                        },
                        [
                          _c(
                            "vs-button",
                            {
                              attrs: {
                                color: "warning",
                                size: "small",
                                type: "border",
                                "data-cy": "add-permission"
                              },
                              on: {
                                "~click": function($event) {
                                  return _vm.addRol(role)
                                }
                              }
                            },
                            [_vm._v(" Agregar ")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ]
              },
              [
                _c("b-skeleton", {
                  attrs: { animation: "fade", width: "70%" }
                }),
                _c("b-skeleton", {
                  attrs: { animation: "fade", width: "80%" }
                }),
                _c("b-skeleton", {
                  attrs: { animation: "fade", width: "60%" }
                }),
                _c("b-skeleton", {
                  attrs: { animation: "fade", width: "85%" }
                }),
                _c("b-skeleton", { attrs: { animation: "fade", width: "70%" } })
              ],
              1
            )
          ],
          2
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-md-6" },
      [
        _c(
          "vs-list",
          { staticClass: "box-users" },
          [
            _vm._l(_vm.rolesList, function(role) {
              return _c(
                "div",
                { key: role.rolId, attrs: { "data-cy": "remove-permission" } },
                [
                  role.asignado === "si"
                    ? _c(
                        "vs-list-item",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: role.descripcion,
                              expression: "role.descripcion"
                            }
                          ],
                          attrs: { title: role.nombre }
                        },
                        [
                          !role.nombre.includes("Usuario básico")
                            ? _c("vs-button", {
                                attrs: {
                                  color: "danger",
                                  size: "small",
                                  type: "border",
                                  icon: "highlight_off",
                                  "data-cy": "remove-permission"
                                },
                                on: {
                                  "~click": function($event) {
                                    return _vm.removeRol(role)
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ]
              },
              [
                _c("b-skeleton", {
                  attrs: { animation: "fade", width: "70%" }
                }),
                _c("b-skeleton", {
                  attrs: { animation: "fade", width: "80%" }
                }),
                _c("b-skeleton", {
                  attrs: { animation: "fade", width: "60%" }
                }),
                _c("b-skeleton", {
                  attrs: { animation: "fade", width: "85%" }
                }),
                _c("b-skeleton", { attrs: { animation: "fade", width: "70%" } })
              ],
              1
            )
          ],
          2
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "w-100 p-4 d-flex justify-end" },
      [
        _c(
          "vs-button",
          {
            attrs: { color: "primary", type: "border", "data-cy": "apply" },
            on: { click: _vm.save }
          },
          [
            _vm._v(" Aplicar "),
            _c("span", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.writing,
                  expression: "writing"
                }
              ],
              staticClass: "spinner-border spinner-border-sm text-white"
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6 border-right mb-3" }, [
      _c("h5", [_vm._v("Roles Asignados")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }